import api from './api';

export interface LegacyListParams {
  page: number;
  limit: number;
  search?: string;
  orgId?: number;
  includeDeleted?: boolean;
}

export interface LegacyListResponse<T> {
  data: T[];
  meta: { total: number; page: number; limit: number };
}

export interface LegacyClient {
  id: number;
  orgId: number | null;
  orgName: string | null;
  fullName: string;
  status: string | null;
  sex: string | null;
  login: string | null;
  phone: string | null;
  bornYear: number | null;
  registeredAt: string | null;
  lastEventAt: string | null;
  lastPaymentAt: string | null;
  lastPaymentSum: number | null;
  selfRegistered: boolean;
  createdById: number | null;
  createdByName: string | null;
  isDeleted: boolean;
}

export interface LegacyExpert {
  id: number;
  orgId: number | null;
  orgName: string | null;
  fullName: string;
  role: string | null;
  specialization: string | null;
  login: string | null;
  sex: string | null;
  registeredAt: string | null;
  isSubscribed: boolean;
  isTelegramSubscribed: boolean;
  isDeleted: boolean;
}

export interface LegacyOrg {
  id: number;
  name: string | null;
  pack: string | null;
  country: string | null;
  locale: string | null;
  isTrial: boolean;
  trialEndsAt: string | null;
  isSolvent: boolean;
  isSuspended: boolean;
  paidUntil: string | null;
  clientsCount: number;
  expertsCount: number;
  activeAppClients: number | null;
  createdAt: string | null;
  isDeleted: boolean;
}

const list = async <T,>(path: string, params: LegacyListParams): Promise<LegacyListResponse<T>> => {
  const response = await api.get(`/pm/legacy/${path}`, {
    params: { ...params, search: params.search || undefined, orgId: params.orgId || undefined, includeDeleted: params.includeDeleted || undefined },
  });
  return { data: response.data.data, meta: response.data.meta };
};

/** Legacy (old studio) data for the product panel, read-only. */
export const pmLegacyService = {
  getClients: (params: LegacyListParams) => list<LegacyClient>('clients', params),
  getExperts: (params: LegacyListParams) => list<LegacyExpert>('experts', params),
  getOrgs: (params: LegacyListParams) => list<LegacyOrg>('orgs', params),
};
